import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-description',
  templateUrl: './add-edit-description.component.html',
  styleUrls: ['./add-edit-description.component.css']
})
export class AddEditDescriptionComponent implements OnInit {
  reference: any;
  isDescription:boolean;
  
  constructor(
    private dialogRef: MatDialogRef<AddEditDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.reference = data;
  }

  form = new FormGroup({
    method:new FormControl('')
   })

  ngOnInit() {
    this.form.patchValue({ 'method': this.reference.payload })
    this.isDescription = this.reference.method === 'description' ? true : false;  
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close((this.form.get('method').value))
  }

}
